<template>
  <!-- 펫 4 바이탈 2x2 패널. 열 우선 → 좌열[🍖배고픔·⚡에너지] / 우열[기분·💤졸림].
       모든 미터 high=good 방향(가득=좋은 상태). meters/moodEmoji는 부모가 주입. -->
  <div class="status-panel">
    <div class="meter-row" :title="`배고픔 ${meters.hunger}/${meters.hungerMax}`">
      <span class="meter-row__icon">🍖</span>
      <v-progress-linear
        class="meter-row__bar"
        :value="hungerPct"
        height="10"
        rounded
        color="#e8743b"
        background-color="#efe2d8"
      />
    </div>
    <div class="meter-row" :title="`에너지 ${meters.energy}/${meters.energyMax}`">
      <span class="meter-row__icon">⚡</span>
      <v-progress-linear
        class="meter-row__bar"
        :value="energyPct"
        height="10"
        rounded
        color="#f2c037"
        background-color="#efe9d6"
      />
    </div>
    <!-- 기분: 아이콘은 현재 mood 버킷 이모지(동적), 바는 mood_meter 비율 -->
    <div class="meter-row" :title="`기분 ${meters.mood}/${meters.moodMax}`">
      <span class="meter-row__icon">{{ moodEmoji }}</span>
      <v-progress-linear
        class="meter-row__bar"
        :value="moodPct"
        height="10"
        rounded
        color="#c77dff"
        background-color="#ece1f5"
      />
    </div>
    <!-- 졸림: awake_meter는 '말짱함'(가득=안 졸림). 라벨/아이콘만 졸림 표현 -->
    <div class="meter-row" :title="`졸림 ${meters.awake}/${meters.awakeMax}`">
      <span class="meter-row__icon">💤</span>
      <v-progress-linear
        class="meter-row__bar"
        :value="awakePct"
        height="10"
        rounded
        color="#5c9ce6"
        background-color="#dde8f4"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PetVitalPanel",
  props: {
    // SupabaseApi.PetStatus.fetchMyMeters() 형태 { hunger,hungerMax,energy,energyMax,mood,moodMax,awake,awakeMax }
    meters: {
      type: Object,
      default: () => ({
        hunger: 0,
        hungerMax: 100,
        energy: 0,
        energyMax: 100,
        mood: 0,
        moodMax: 100,
        awake: 0,
        awakeMax: 100,
      }),
    },
    // 기분 바 아이콘 — 현재 mood 버킷 이모지(부모가 resolveMood로 계산해 주입).
    moodEmoji: { type: String, default: "🙂" },
  },
  computed: {
    hungerPct() {
      const m = this.meters;
      return m.hungerMax > 0 ? Math.round((m.hunger / m.hungerMax) * 100) : 0;
    },
    energyPct() {
      const m = this.meters;
      return m.energyMax > 0 ? Math.round((m.energy / m.energyMax) * 100) : 0;
    },
    moodPct() {
      const m = this.meters;
      return m.moodMax > 0 ? Math.round((m.mood / m.moodMax) * 100) : 0;
    },
    // awake_meter는 '말짱함'(high=good) → 가득하면 안 졸림.
    awakePct() {
      const m = this.meters;
      return m.awakeMax > 0 ? Math.round((m.awake / m.awakeMax) * 100) : 0;
    },
  },
};
</script>

<style scoped>
/* 4 바이탈 2x2. 열 우선 채움 → 좌열[🍖배고픔·⚡에너지] / 우열[기분·💤졸림] */
.status-panel {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  column-gap: 12px;
  row-gap: 6px;
  margin-top: 2px;
}
.meter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.meter-row__icon {
  font-size: 15px;
  width: 18px;
  text-align: center;
  flex: 0 0 18px;
}
.meter-row__bar {
  flex: 1 1 auto;
  border-radius: 999px;
}
</style>
